module.exports = __webpack_public_path__ + "static/media/AB_S3.f48155f3.JPG";